<template>
    <div class="no-body" :style="{'padding-top':paddNum,'padding-bottom':paddNum,}">
        <div class="no-data">
            <img src="../../assets/imgs/no-data.jpg" alt="">
        </div>
        <p class="no-info">{{infoFont}}</p>
    </div>
</template>

<script>
    export default {
        name: "nodata",
        props:[
            'msg',
            'padding'
        ],
        data(){
            return{
                infoFont:this.$t("noresult"),
                paddNum:'2rem',
            }
        },
        mounted(){
            if(this.msg && this.msg != ''){
                this.infoFont = this.msg;
            }
            if(this.padding && this.padding != ''){
                this.paddNum = this.padding/100+'rem';
            }
        }
    }
</script>

<style scoped>
    .no-body{
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .no-data{
        width: 100%;
        height: auto;
    }
    .no-data img{
        display: block;
        margin: 0 auto;
    }
    .no-info{
        text-align: center;
        font-size: 0.36rem;
        line-height: 0.36rem;
        padding: 0.4rem 0 0.2rem;
        color: #7da7a3;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/nodata.vue